<template>
  <div id="content" class="main-content">
    <div class="layout-px-spacing">
      <div class="row layout-spacing">
        <!-- Content -->
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 layout-top-spacing">
          <div class="user-profile layout-spacing">
            <div class="widget-content widget-content-area">
              <!-- <div class="d-flex justify-content-between">
                <div>
                  <div class="alert alert-success mb-4" role="alert">
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                      <svg>...</svg>
                    </button>
                  </div>
                </div>
                <br />
                <br />
                <div>
                  <div class="alert alert-danger mb-4" role="alert">
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                      <svg>...</svg>
                    </button>
                  </div>
                </div>
              </div> -->
              <div class="text-center user-info" v-if="userProfile">
                <img src="/assets/img/90x90.jpg" alt="avatar" />
                <p class>{{userProfile.local.fullname}}</p>
              </div>
              <div class="user-info-list" v-if="userProfile">
                <div class>
                  <ul class="contacts-block list-unstyled">
                    <li class="contacts-block__item">Phone: {{userProfile.local.phone}}</li>
                    <li class="contacts-block__item">Email: {{userProfile.local.email}}</li>
                    <li class="contacts-block__item">Gender: {{userProfile.local.gender}}</li>
                    <li v-if="userProfile.local.birthdate" class="contacts-block__item">Date of Birth: {{userProfile.local.birthdate}}</li>
                    <li class="contacts-block__item">Marital Status: {{userProfile.local.maritalstatus}}</li>
                    <!-- <li class="contacts-block__item">Location: Lagos</li>
                    <li class="contacts-block__item">Property Name: VGC</li> -->
                  </ul>
                  <div v-if="error" id="error" class="center-i">
                      <p class="color-red">{{error}}</p>
                  </div>
                  <div class="text-center" v-if="userType == 'owner' || userType == 'sub-admin'">
                    <!-- Success -->
                    <button class="btn btn-success mb-2 mr-3" :disabled="userProfile.local.activated || disable" @click="acceptUser">Accept</button>

                    <!-- Danger -->
                    <button class="btn btn-danger mb-2" :disabled="!userProfile.local.activated || disable" @click="declineUser">Reject</button>
                    <br />
                  </div>
                </div>
              </div>
              <div class="user-info-list center-i" v-if="!userProfile && !userError">
                <h3>Loading User Data</h3>
              </div>
              <div class="user-info-list center-i" v-if="userError">
                <h3>{{userError}}</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-wrapper">
      <div class="footer-section f-section-1">
        <p class>
          Copyright © 2020
          <a target="_blank" href="https://designreset.com">DesignReset</a>, All rights reserved.
        </p>
      </div>
      <div class="footer-section f-section-2">
        <p class>
          Coded with
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="feather feather-heart"
          >
            <path
              d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"
            />
          </svg>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data(){
    return {
      userType: '',
      userId: '',
      userProfile: null,
      error: '',
      userError: '',
      disable: false,
    }
  },
  mounted(){
    this.userType = this.$route.params.type;
    this.userId = this.$route.params.userId;

    this.userId && this.userType && this.getUser(this.userId, this.userType);
  },
  methods:{
    getUser(userId, userType){
      const token = this.$store.state.token;
      this.userError = '';
      const USER_TYPE = {
        'sub-admin': 'getSubAdmin',
        'owner': 'getOwner',
        'user': 'getUser',
      };

      const url = `${process.env.VUE_APP_SERVER_URL}/master/${USER_TYPE[userType]}/${userId}`;
      
      axios({
          method: 'get',
          url,
          headers: {
              'Authorization': `Bearer ${token}`,
              'Access-Control-Allow-Origin': '*',
              'Access-Control-Allow-Headers': '*',
          }
      }).then((res) => {
        let admin = res.data.admin || res.data.user;
        let user = {}
        if(!admin.local) {
          user.local = admin;
          user.local.fullname = admin.fullName;
          user.local.activated = admin.isVerified;
          user.local.maritalstatus = admin.maritalStatus;
          user._id = admin._id
        }else{
          user = admin;
        }
        this.userProfile = user;
        this.disable = false
      }).catch((error)=>{
        this.userError = 'Unable to fetch User data';

        console.log('error', error);
      });

    },
    updateUser(url){
      this.error = '';
      this.disable = true;

      const token = this.$store.state.token;
      axios({
          method: 'put',
          url,
          headers: {
              'Authorization': `Bearer ${token}`,
              'Access-Control-Allow-Origin': '*',
              'Access-Control-Allow-Headers': '*',
          }
      }).then(() => {
        this.getUser(this.userId, this.userType)
      }).catch(()=>{
        this.error = 'an Error occured';
        this.disable = false
      })
    },
    acceptUser(){
      const userType = {
        'sub-admin': `sub-admin/${this.userId}`,
        'owner': this.userId,
      }
      let url = `${process.env.VUE_APP_SERVER_URL}/master/activate/${userType[this.userType]}`;
      this.updateUser(url);
    },
    declineUser(){
      const userType = {
        'sub-admin': `sub-admin/${this.userId}`,
        'owner': this.userId,
      }
      let url = `${process.env.VUE_APP_SERVER_URL}/master/deactivate/${userType[this.userType]}`;
      this.updateUser(url);
    }
  }
};
</script>

<style scoped>
.color-red {
    color: red;
}
.center-i {
    display: flex;
    justify-content: center;
}
</style>